<!--
 * @Author: ShiWeiShan
 * @Date: 2020-12-28 09:42:10
 * @LastEditTime: 2020-12-28 09:57:46
 * @LastEditors: ShiWeiShan
 * @Description: 收费凭证上传表单
 * @FilePath: \fs-js-pcweb-user\src\components\applyForm\billUploadForm.vue
-->
<template>
  <div class="bill-upload-form">
    <el-form
      :model="formreceipt"
      label-width="108px"
      ref="saveformreceipt"
      :rules="formreceiptRules"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="计划户编号" prop="user_code">
            <el-input v-model="formreceipt.user_code" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="计划户名称:" prop="user_name">
            <el-input v-model="formreceipt.user_name" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="收费周期:" prop="bill_id">
            <el-input v-model="formreceipt.bill_id" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="应收金额(元):" prop="raise_sum">
            <el-input v-model="formreceipt.raise_sum" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="到账金额(元):" prop="pay_amount">
            <el-input v-model="formreceipt.pay_amount"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="到账日期:" prop="charge_date">
            <el-date-picker v-model="formreceipt.charge_date" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="文件:" prop="file_1">
        <common-upload v-model="formreceipt.file_1" fileAccept="image/jpeg,application/pdf"></common-upload>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" slot="footer">
      <el-button type="primary" @click="handlecancel">取 消</el-button>
      <el-button type="success" @click="handlesave">提交</el-button>
    </div>
  </div>
</template>

<script>
import commonUpload from '@/components/public/commonUpload'
export default {
  components: {
    commonUpload
  },
  props: {
    billData: Object
  },
  data () {
    return {
      formreceipt: {
        user_code: "", // 计划户编号
        user_name: "", // 计划户名称
        bill_id: "", // 收费周期
        raise_sum: "", // 应收金额(元)
        pay_amount: "", // 到账金额(元)
        charge_date: "" // 到账日期
      }, // 收费凭证表单数据集合
      formreceiptRules: {
        bill_id: [{ required: true, message: "请选择收费周期", trigger: "change" }],
        pay_amount: [{ required: true, message: '金额不能为空', trigger: 'change' }],
        charge_date: [{ required: true, message: "到账日期不能为空", trigger: "change" }],
        file_1: [{ required: true, message: '请上传文件', trigger: 'change' }]
      } // 收费凭证表单校验
    }
  },
  methods: {
    get_listdata () {
      this.formreceipt.user_code = this.billData.user_code // 计划户编号
      this.formreceipt.user_name = this.billData.user_name // 计划户名称
      this.formreceipt.bill_id = this.billData.s_time + '-' + this.billData.e_time // 收费周期
      this.formreceipt.raise_sum = this.billData.raise_sum // 应收金额(元)
    },
    // 功能：保存按钮事件(收费凭证)
    handlesave () {
      this.$refs.saveformreceipt.validate((valid) => {
        if (valid) {
          this.$confirm('确认保存？', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            let formData = new FormData()
            if (this.formreceipt.file_1 != null) {
              this.formreceipt.file_1.forEach(item => {
                formData.append('file_1', item)
              })
            }
            formData.append('user_id', this.billData.user_id)
            formData.append('bill_id', this.billData.oid)
            formData.append('pay_amount', this.formreceipt.pay_amount)
            formData.append('charge_date', this.formreceipt.charge_date)
            const R = await A_ADD_Waterreceipt(formData)
            if (R.data.Type === 0) {
              this.$message({
                showClose: true,
                message: R.data.Description,
                type: 'error'
              })
              return false
            }
            this.$emit('successThen')
            this.$message({
              showClose: true,
              message: '操作成功！',
              type: 'success'
            })
          })
        } else {
          this.$message({
            showClose: true,
            message: '请正确填写表单！',
            type: 'warning'
          })
          return false
        }
      })
    },
    handlecancel () {
      this.$emit('cancel')
    }
  },
  mounted () {
    this.get_listdata()
  }
}
</script>

<style lang="scss" scoped>
.bill-upload-form{
  padding: 12px;
  .dialog-footer {
    margin-top: 25px;
    text-align: right;
  }
}
</style>